// extracted by mini-css-extract-plugin
export default {"toolbar":"PageToolbar-toolbar-YMl38"};